import { render, staticRenderFns } from "./ClientServiceSpotFilters.vue?vue&type=template&id=12196214"
import script from "./ClientServiceSpotFilters.vue?vue&type=script&lang=js"
export * from "./ClientServiceSpotFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports